const SiteTheme = () =>
  import(
    /* webpackChunkName: "site-generator-cms-theme" */ '@/pages/site-generator/cms/theme/index.vue'
  )
const CreateSiteTheme = () =>
  import(
    /* webpackChunkName: "site-generator-cms-theme" */ '@/pages/site-generator/cms/theme/create.vue'
  )
const EditSiteTheme = () =>
  import(
    /* webpackChunkName: "site-generator-cms-theme" */ '@/pages/site-generator/cms/theme/edit.vue'
  )

export default {
  path: 'theme',
  meta: {
    label: 'theme',
    auth: 'theme'
  },
  component: {
    name: 'Theme',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteThemeReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SiteTheme
    },
    {
      name: 'SiteCreateTheme',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSiteTheme
    },
    {
      name: 'SiteEditTheme',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSiteTheme,
      props: true
    }
  ]
}
